import React, { Component } from 'react';
import { evaluate } from '@tencent/workbench';
import Checkbox from '@tencent/dui/lib/components/Checkbox';
import styles from './checkbox.less.js';

class CheckboxFormItem extends Component {
    constructor() {
        var _a;
        super(...arguments);
        this.value = (_a = this.props.defaultValue) !== null && _a !== void 0 ? _a : false;
        this.handleChange = (checked) => {
            var _a, _b;
            this.value = checked;
            (_b = (_a = this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, checked);
            this.forceUpdate();
        };
    }
    render() {
        const value = evaluate(this.props.value, this.value);
        const options = evaluate(this.props.options, {});
        return React.createElement(Checkbox, Object.assign({ onChange: this.handleChange, checked: value, className: styles.checkbox }, options), this.props.label);
    }
}

export { CheckboxFormItem };
//# sourceMappingURL=checkbox.js.map
